export default __webpack_public_path__ + "static/main-cd760596039806fa34e22f1f5a6ec603.jpg";